import { useEffect } from "react";
import { newProductPlanActions } from "redux/Ldb/actions/newProductPlanActions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const useGetSingleNewProductPlan = (params?: { id: string }, options: { skip?: boolean } = {}) => {
    const { id } = params || {};
    const { skip = false } = options;
    const dispatch = useAppDispatch();

    const {
        fetchingSingleNewProductPlan,
        fetchedSingleNewProductPlanSuccess,
        fetchedSingleNewProductPlanFailure,
    } = useAppSelector((state) => state.newProductPlan);

    useEffect(() => {
        if (!skip && id) {
            dispatch(newProductPlanActions.fetchSingleNewProductPlan(id));
        }
    }, [id, skip, dispatch]);

    const refetch = () => {
        if (id) {
            dispatch(newProductPlanActions.fetchSingleNewProductPlan(id));
        }
    };

    const resetSingleNewProductPlan = () => {
        dispatch(newProductPlanActions.resetFetchSingleNewProductPlan());
    };

    useEffect(() => {
        resetSingleNewProductPlan();
    }, []);

    return {
        isSuccess: Boolean(fetchedSingleNewProductPlanSuccess),
        isError: Boolean(fetchedSingleNewProductPlanFailure),
        isLoading: fetchingSingleNewProductPlan,
        data: fetchedSingleNewProductPlanSuccess,
        error: fetchedSingleNewProductPlanFailure,
        refetch,
        resetSingleNewProductPlan,
    };
};

export default useGetSingleNewProductPlan;
